<template>
  <div>
    <div class="wrap-live" v-if="verVideo">
      <div class="container">
        <div class="row d-block d-sm-flex" :class="{'justify-content-center': lateralHide}">
          <div class="wrapper-click" v-if="!init">
            <div @click="initLive()" class="btn-init">
              Iniciar Live
            </div>
          </div>

          <div class="position-absolute timer-overlay" v-if="!chat">
            <Timer deadline="+002022-08-04T12:00:00" :mobile="true" />
          </div>
          <!-- Video col -->
          <div class="p-0 col-sm-6">
            <Video :videoUrl="videoUrl" v-if="renderComponent"></Video>
            <OfferSlidder :hideMobile="true" />
          </div>
          <!-- Video col -->

          <!-- Second col -->
          <div class="col-12 col-sm-6 p-0" v-if="!lateralHide">
            <div class="main-btn-container">
              <div class="btn-container">
                <button :class="{ 'active': toggleDiv, 'inactive': !toggleDiv }" @click="toggleOffer('chat')">
                  Ofertas
                </button>
              </div>
              <div class="btn-container">
                <button :class="{ 'inactive': toggleDiv, 'active': !toggleDiv }" @click="toggleOffer('offer')">
                  Chat
                </button>
              </div>
            </div>
            <div class="d-flex side-container">
              <div :class="{ 'col-12': true, 'd-none': !toggleDiv, 'd-flex justify-content-center': toggleDiv }">
                <div v-if="!offersHide">
                  <Productos />
                </div>
                <div v-else="offersHide">
                  <div class="inactive-chat">
                    <div class="txt-container">
                      <p class="mb-0">Actualmente no hay ofertas activas<br>😅</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 d-flex" v-if="!toggleDiv">
                <div class="chat" v-if="chat">
                  <Chat :origen="origen" @chathidden="chathidden" />
                  <sentimiento  v-if="likes"/>
                </div>
                <div class="chat" v-else="chat">
                  <div class="inactive-chat">
                    <div class="txt-container">
                      <p class="mb-0">El chat de esta emisión en directo<br>está inhabilitado 😅</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            
          </div>
          <OfferSlidder :hideMobile="false" />
          <!-- Second col -->


        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.chat {
  position: relative;
  background: #FFF;
  width: 50vw;

  @media(max-width: 701px) {
    height: 220px;
  }

  @media(max-width: 576px) {
    width: 100vw;
  }

  
}

.inactive-chat {
  max-height: 80vh;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  .txt-container {
    background-color: #218AFF;
    color: #fff;
    padding: 25px 40px;
    font-weight: 700;
    border-radius: 20px;
    box-shadow: 5px 5px 15px #00000040;

    @media(max-width:701px) {
      padding: 10px 20px;
    }
  }

  @media (max-width: 576px) {
    height: 200px;
  }
}

.side-container {
  max-height: calc(100vh - 50px);
  height: 100%;
  @media (max-width: 701px) {
    height: 250px;
  }
}

.main-btn-container {
  width: 100%;
  display: flex;

  .btn-container {
    width: 50%;
    padding: 0px 15px 10px 15px;
    text-align: center;

    @media(max-width: 576px) {
      padding: 10px 15px 0px 15px;
    }

    .active {
      position: relative;
      border: none;
      color: #000;
      background-color: transparent;
      font-weight: 800;


      &:before {
        content: '';
        position: absolute;
        bottom: 0;
        width: 0;
        left: 0;
        height: 2px;
        background-color: #000;
        animation: .5s test forwards;
      }

    }

    .inactive {
      background-color: transparent;
      border: none;
      color: #1b1b1b;
      font-weight: 800;

    }
  }
}


@keyframes test {
  from {}

  to {
    left: 0;
    right: auto;
    width: 100%;
  }
}
</style>
<script>
import Vue from "vue";
import fire from "./../fire";
import 'firebase/messaging';
import Chat from "@/components/Chat";
import Video from "@/components/Video";
import Productos from "@/components/Productos";
import Sentimiento from "@/components/Sentimiento";
import VueSweetalert2 from "vue-sweetalert2";
import mixin from "../mixins"
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import Timer from "@/components/Timer";
import OfferSlidder from "./OfferSlidder.vue";
Vue.use(VueSweetalert2);

export default {
  name: "LiveShop",
  // eslint-disable-next-line vue/no-unused-components
  components: {
    Chat,
    Video,
    Productos,
    Sentimiento,
    Timer,
    VueSlickCarousel,
    OfferSlidder
  },
  mixins: [mixin],
  data() {
    return {
      origen: false,
      showmodal: false,
      ofertas: false,
      chatVisible: true,
      chat: false,
      verVideo: false,
      videoUrl: "",
      overlay: false,
      titulo: "",
      modalData: [],
      config: [],
      sentimientos: [],
      numerolike: 0,
      likes: true,
      renderComponent: false,
      init: true,
      toggleDiv: true,
      lateralHide: false,
      offersHide: false,
    }
  },
  methods: {
    cerrar() {
      this.showmodal = false;
      this.overlay = false;
    },
    chathidden() {
      this.chatVisible = !this.chatVisible
    },
    mostrarModal(data) {
      console.log('dataModal', data);
      if (data.url) {
        window.open(data.url, '_blank').focus();
      } else {
        this.modalData = data;
        this.showmodal = true;
        this.overlay = true;
        console.log('pass data to modal:', this.modalData)
      }
    },
    toggleOffer(div) {
      if (div === 'chat') {
        this.toggleDiv = true;
      } else if (div === 'offer') {
        this.toggleDiv = false;
      }
    },
    initLive() {
      this.init = true;
    }
  },
  mounted() {
    document.getElementById('app').classList.add('liveshop');
    let ref = this;
    const itemsRef = fire.database().ref("config");
    itemsRef.on("value", snapshot => {
      let data = snapshot.val();
      if (data.chat === true) {
        ref.chat = true;
      } else {
        ref.chat = false;
      }

      if (data.verVideo === true) {
        ref.verVideo = true;
      } else {
        ref.verVideo = false;
      }

      ref.videoUrl = data.video;
      ref.videoMobile = data.videoMobile;
      ref.titulo = data.titulo;
      ref.contador = data.contador;
      ref.bannerContador = data.bannerContador;
      ref.fecha = data.fecha;
      ref.likes = data.likes;
      ref.suscripcion = data.suscripcion;
      ref.lateralHide = data.lateralHide;
      ref.offersHide = data.offersHide;
    });
    window.scrollTo(0, 0);
  },
  created() {
    if (this.$route.query.origen == 'samsung') {
      this.origen = true;
    }
    window.scrollTo(0, 0);
  },
  watch: {
    videoUrl: function () {
      this.renderComponent = false
      this.$nextTick(() => {
        this.renderComponent = true
      })
    }
  }
}
</script>